import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { ComponentType } from '@angular/cdk/portal';

import { FilterBarField, SelectedFilterField } from '@cdw-ae/filter-bar-interfaces';
import { FilterBarDialogComponent } from '../filter-bar-dialog/filter-bar-dialog.component';

@Component({
  selector: 'cdw-ae-filter-bar',
  template: `
    <cdw-ae-filter-bar-core
      [filterBarField]="filterBarField"
      [limitOneFilter$]="limitOneFilter$"
      [initialSelectedFilterFields$]="initialSelectedFilterFields$"
      [fieldMask$]="fieldMask$"
      [autoLimitField]="autoLimitField"
      [dialogComponent]="dialogComponent"
      (filtersChange)="onFiltersChange($event)"
      (filterBarInputChanged)="onFilterBarInputChanged($event)"
    ></cdw-ae-filter-bar-core>
  `,
  standalone: false,
})
export class FilterBarWrapperComponent {
  @Input() public filterBarField: FilterBarField[] = [];
  @Input() public limitOneFilter$: Observable<boolean> | undefined;
  @Input() public initialSelectedFilterFields$: Observable<SelectedFilterField[]> | undefined;
  @Input() public fieldMask$: Observable<string[]> | undefined;
  @Input() public autoLimitField = true;

  @Output() filtersChange = new EventEmitter<SelectedFilterField[]>();
  @Output() filterBarInputChanged = new EventEmitter<string | null>();

  // Provide the dialog component to the core component
  public dialogComponent: ComponentType<unknown> = FilterBarDialogComponent;

  public onFiltersChange(filters: SelectedFilterField[]): void {
    this.filtersChange.emit(filters);
  }

  public onFilterBarInputChanged(input: string | null): void {
    this.filterBarInputChanged.emit(input);
  }
}